import actionType from '../actions/record/actionType';

const initialState = {
  // 改价审批记录列表
  recordList: [],
  searchValue: {
    startDate: null,
    endDate: null,
    pageNum: 1,
    pageSize: 50,
  },
  total: 0,
  recordLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.RECORD_LSIT:
      return {
        ...state,
        recordList: action.payload.recordList,
        total: action.payload.total,
        searchValue: {
          ...state.searchValue,
          pageNum: action.payload.pageNum,
        },
      };
    case actionType.SET_RECORD_SEARCH_VALUE:
      return {
        ...state,
        searchValue: {
          ...state.searchValue,
          ...action.payload,
        },
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
